module.exports = __webpack_public_path__ + "img/gamanon.7fa49f84.svg";